import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  balancesWrapper: {
    maxHeight: theme.spacing(250),
  },
  topUpHistoryWrapper: {
    padding: theme.spacing(0, 9),
  },
}));
